import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Quest/PortfolioScenarios/Domain/queries';
import Component from 'vue-class-component';

@Component
export default class PortfolioScenariosQueries extends VueCqrs
{
	runPortfolioScenariosPageQueryV1(workspaceId: number, tchProjectId: number)
	{
		const query = q.buildPortfolioScenariosPageQueryV1(workspaceId, tchProjectId);
		this.$query(query);
	}

	runProjectsPageQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string)
	{
		const query = q.buildProjectsPageQueryV1(workspaceId, tchProjectId, scenarioId);
		this.$query(query);
	}

	runSelectionPageQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string)
	{
		const query = q.buildSelectionPageQueryV1(workspaceId, tchProjectId, scenarioId);
		this.$query(query);
	}

	runSchedulingPageQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string)
	{
		const query = q.buildSchedulingPageQueryV1(workspaceId, tchProjectId, scenarioId);
		this.$query(query);
	}

	runApprovalPageQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string)
	{
		const query = q.buildApprovalPageQueryV1(workspaceId, tchProjectId, scenarioId);
		this.$query(query);
	}

	runReviewPageQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string)
	{
		const query = q.buildReviewPageQueryV1(workspaceId, tchProjectId, scenarioId);
		this.$query(query);
	}

	runCriteriaPageQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string)
	{
		const query = q.buildCriteriaPageQueryV1(workspaceId, tchProjectId, scenarioId);
		this.$query(query);
	}

	runNewScenarioSettingsQueryV1(workspaceId: number, portfolioId: string, corporateScenarioId: string)
	{
		const query = q.buildNewScenarioSettingsQueryV1(workspaceId, portfolioId, corporateScenarioId);
		this.$query(query);
	}

	runExistingScenarioSettingsQueryV1(workspaceId: number, portfolioId: string, portfolioScenarioId: string)
	{
		const query = q.buildExistingScenarioSettingsQueryV1(workspaceId, portfolioId, portfolioScenarioId);
		this.$query(query);
	}


	runPnlPageQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string)
	{
		const query = q.buildPnlPageQueryV1(workspaceId, tchProjectId, scenarioId);
		this.$query(query);
	}

	runPortfolioScenarioPnlQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string, applyBenefitsConfidenceFactor: boolean, pnlTemplateId: string, denomination: string)
	{
		const query = q.buildPortfolioScenarioPnlQueryV1(workspaceId, tchProjectId, scenarioId, applyBenefitsConfidenceFactor, pnlTemplateId, denomination);
		this.$query(query);
	}

	runResourceConstraintPageQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string, resourceId: string)
	{
		const query = q.buildResourceConstraintPageQueryV1(workspaceId, tchProjectId, scenarioId, resourceId);
		this.$query(query);
	}


	runSelectorSettingsQueryV1(workspaceId: number, portfolioId: string, scenarioId: string)
	{
		const query = q.buildSelectorSettingsQueryV1(workspaceId, portfolioId, scenarioId);
		this.$query(query);
	}
}